export const LOAD_PRODUCTS_DATA = 'storeHome/LOAD_PRODUCTS_DATA';
export const SET_PRODUCTS_STATUS = 'storeHome/SET_PRODUCTS_STATUS';
export const SET_PRODUCTS_DATA = 'storeHome/SET_PRODUCTS_DATA';

export const LOAD_ITEM_COMMENTS_DATA = 'storeHome/LOAD_ITEM_COMMENTS_DATA';
export const SET_ITEM_COMMENTS_STATUS = 'storeHome/SET_ITEM_COMMENTS_STATUS';
export const SET_ITEM_COMMENTS_DATA = 'storeHome/SET_ITEM_COMMENTS_DATA';

export const LOAD_CATEGORY_COMMENTS_DATA = 'storeHome/LOAD_CATEGORY_COMMENTS_DATA';
export const SET_CATEGORY_COMMENTS_STATUS = 'storeHome/SET_CATEGORY_COMMENTS_STATUS';
export const SET_CATEGORY_COMMENTS_DATA = 'storeHome/SET_CATEGORY_COMMENTS_DATA';

export const SET_IS_STOCK_ORDER = 'storeHome/SET_IS_STOCK_ORDER';